import React, { useState, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import SEO from "../components/SEO";
import BlogCard from "../components/BlogCard";
import useReveal from "../hooks/useReveal";
import { getAllPosts, getCategories } from "../data/blog";
import { SITE } from "../config/site";

export default function Blog() {
  const { t } = useTranslation();
  const pageRef = useRef(null);
  const [filter, setFilter] = useState("all");
  const posts = useMemo(() => getAllPosts(), []);
  const categories = useMemo(() => getCategories(), []);
  useReveal(pageRef, [t, filter]);

  const shown = filter === "all" ? posts : posts.filter((p) => p.category === filter);

  const ld = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: t("blog.meta_title"),
    url: `${SITE.url}/blog`,
    publisher: { "@type": "Organization", name: SITE.name },
  };

  return (
    <div ref={pageRef}>
      <SEO title={t("blog.meta_title")} description={t("blog.meta_desc")} jsonLd={ld} />

      <section className="blog-hero">
        <div className="container">
          <span className="eyebrow reveal">{t("blog.hero.eyebrow")}</span>
          <h1 className="reveal d1">{t("blog.hero.title_1")} <span className="accent">{t("blog.hero.title_hl")}</span></h1>
          <p className="lede reveal d2">{t("blog.hero.lede")}</p>
        </div>
      </section>

      <section style={{ paddingBottom: "clamp(64px,9vw,120px)" }}>
        <div className="container">
          <div className="blog-filters">
            <button className={`filter-chip${filter === "all" ? " active" : ""}`} onClick={() => setFilter("all")}>{t("blog.all")}</button>
            {categories.map((c) => (
              <button key={c} className={`filter-chip${filter === c ? " active" : ""}`} onClick={() => setFilter(c)}>
                {t(`blog.categories.${c}`)}
              </button>
            ))}
          </div>

          {shown.length ? (
            <div className="blog-grid">
              {shown.map((p, i) => (
                <div className="reveal" style={{ transitionDelay: `${(i % 3) * 0.06}s` }} key={p.slug}>
                  <BlogCard post={p} />
                </div>
              ))}
            </div>
          ) : (
            <p className="muted">{t("blog.empty")}</p>
          )}
        </div>
      </section>
    </div>
  );
}
